module.exports = __webpack_public_path__ + "static/image/DPA.svg?9ea3c28c90572fd77db43d5de5156444";